export const numericInputStore = {
  namespaced: true,
  state: {
    value: "",
    sourceValue: "",
    sourceRecord: {
      itemCode: null,
      value: null,
    },
    key: 0,
    fieldFocused: false,
    lastEntry: {
      value: undefined,
      remove: false
    }
  },
  actions: {
    async updateRecord({ commit }, record) {
      commit("setNumericValue", record.value);
      commit("setSourceNumericValue", record.value);
      commit("setSourceRecord", record);
    },
    async updateValue({ commit, state }, value) {
      commit("setNumericValue", value);
      commit("setSourceNumericValue", value);
      commit("setSourceRecord", {
        itemCode: state.sourceRecord.itemCode,
        value: value,
      });
    },
    async updateSourceNumericValue({ commit }, value) {
      commit("setSourceNumericValue", value);
    },
    async keyPadFocusChanged({ commit }) {
      commit("updateKey");
    },
    async setFieldFocused({ commit }, value) {
      commit("setFieldFocused", value);
    },
    async lastEntry({ commit }, value) {
      commit("setLastEntry", value);
    }
  },
  mutations: {
    setNumericValue(state, value) {
      state.value = value;
    },
    setSourceRecord(state, record) {
      state.sourceRecord = record;
    },
    setSourceNumericValue(state, value) {
      state.sourceValue = value;
    },

    updateKey(state) {
      state.key = state.key + 1;
    },

    setFieldFocused(state, value) {
      state.fieldFocused = value;
    },
    setLastEntry(state, value) {
      state.lastEntry.value = value.value;
      state.lastEntry.remove = value.remove;
    }
  },
  getters: {
    getNumericValue(state) {
      return state.value;
    },
    getSourceNumericValue(state) {
      return state.sourceValue;
    },
    getSourceNumericRecord(state) {
      return state.sourceRecord;
    },
    getKeyPadFocusChanged(state) {
      return state.key;
    },

    getFieldFocused(state) {
      return state.fieldFocused;
    },
    getLastEntry(state) {
      return state.lastEntry;
    }
  },
};
